'use strict';
const NotificationBuilder = require('./NotificationBuilder');

class SuccessfulNotificationBuilder extends NotificationBuilder {
    constructor(id, keys) {
        super(id, keys);
        this.type = 'success';
        this.options = this.constructor.getDefaultOptions();
    }

    static getDefaultOptions() {
        return {
            headerIconClass: 'odf-icon-tick',
            hasCloseIcon: false,
            contentType: 'text',
            hasCTA: true,
            hasRedBox: false,
        };
    }
}

module.exports = SuccessfulNotificationBuilder;
